import { Route } from 'react-router-dom';

import { BudgetUse } from './budget-use/budget-use.component';

export function ApplicationBudgetsRoutes() {
    return (
        <Route path='budgets'>
            <Route
                path='uses'
                element={<BudgetUse />}
            />
        </Route>
    );
}
